import CameraIcon from '../../icons/CameraIcon'
import React, { useRef } from "react"
import { useIntl } from "react-intl"
import styled from "styled-components"
import PhotoItem from './photos/PhotoItem'
import { breakpoints } from '../../../core/application/theme/breakpoints'

export interface ISubmitDropoffPhotosProps {
    selectedFiles: File[]
    setSelectedFiles: (files: File[]) => void
}

const SubmitDropoffPhotos: React.FC<ISubmitDropoffPhotosProps> = ({
    selectedFiles,
    setSelectedFiles
}) => {
    const intl = useIntl()
    const fileInput: React.MutableRefObject<any> = useRef()

    return (
        <SubmitDropoffPhotosContainer>
            <Infos>
                {intl.formatMessage({id:'SubmitDropoff.photos.info'})}
            </Infos>
            <FilesInputContainer>
                <FilesInput
                    type="file"
                    id="file"
                    onChange={e => {
                        if (e.target.files) {
                            let fileNames = selectedFiles.map(file => file.name)
                            const newFiles = Array.from(e.target.files).filter(file => {
                                return !fileNames.includes(file.name)
                            })
                            setSelectedFiles([...selectedFiles, ...newFiles])
                        }
                    }}
                    accept="image/*"
                    multiple
                    ref={fileInput}
                />
                <FilesInputButton
                    onClick={e => fileInput.current && fileInput.current.click()}
                >
                    <CameraIcon/>
                    {intl.formatMessage({id:'SubmitDropoff.photos.add'})}
                </FilesInputButton>
            </FilesInputContainer>
            <PicturesContainer>
                {
                    selectedFiles.map((file, index) => {
                        return (
                            <PhotoItem key={index} file={file} onDeletePhoto={() => {
                                const updated = [...selectedFiles]
                                updated.splice(index, 1)
                                setSelectedFiles(updated)
                            }}/>
                        )
                    })
                }
            </PicturesContainer>
            
        </SubmitDropoffPhotosContainer>
    )
}

const PicturesContainer = styled.div`
    margin-top: 18px;
    overflow-x: auto;
    white-space: nowrap;

    @media ${breakpoints.tablet} {
        display: grid;
        width: 100%;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 12px;
        overflow-x: none;
        overflow-y: auto;
        max-height: 300px;
    }
`

const Infos = styled.div`
    text-align: left;
    font-style: normal;
    font-weight: ${({ theme }) => theme.weight.light};
    font-size: ${({ theme }) => theme.size.small};
    color: ${({ theme }) => theme.color.black};
    font-family: ${({ theme }) => theme.font.default};
    margin-bottom: 18px;
    margin-top: 8px;
`

const SubmitDropoffPhotosContainer = styled.div`
    margin-bottom: 14px;
`

const FilesInputContainer = styled.div`

`

const FilesInputButton = styled.button`
    cursor: pointer;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    padding: 12px;
    color: ${({ theme }) => theme.color.secondary};
    background-color: ${({ theme }) => theme.color.primary};
    border-radius: 4px;
    line-height: 1.8em;
    font-size: ${({ theme }) => theme.size.small};
    font-family: ${({ theme }) => theme.font.semi};
    font-weight: ${({ theme }) => theme.weight.semi};

    & svg {
        margin-right: 5px;
    }
`

const FilesInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`


export default SubmitDropoffPhotos
